<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
    id="dropdown-user"
  >
    <template #button-content>
      <!-- <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50 logout-svg"
        @click="logout"
      /> -->
      <feather-icon icon="MenuIcon" size="21" class="menu-svg" />
    </template>
    <div class="profile-detail d-flex align-items-center">
      <div class="image-user">
        <feather-icon icon="UserIcon" size="22" />
      </div>
      <div class="info-section">
        <div>Administrator</div>
        <!-- <div>Manut Boonsakcharint</div> -->
        <div class="text-email" v-if="accountName">
          {{ accountName }}
        </div>
      </div>
    </div>
    <div v-if="changeBrandInfo.isChangeBrand">
      <div class="divider"></div>
      <div class="body-wrp">
        <div
          class="body-dropdown d-flex align-item-center"
          @click="openChangeBrandModal"
        >
          <div class="d-flex align-item-center">
            <change-brand-svg class="icon-change-brand" />
            <div class="text-name-dropdown">Change Brand Account</div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="divider"></div>
      <div class="body-wrp">
        <div
          class="body-dropdown d-flex align-item-center"
          @click="onOpenChangePassword"
        >
          <div class="d-flex align-item-center">
            <change-password-svg class="icon-change-brand" />
            <div class="text-name-dropdown">Change Password</div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
    </div>

    <div class="footer-sign-out">
      <div
        class="sign-out-wrp d-flex justify-content-center align-items-center"
        @click="forceLogout"
      >
        <div>Sign out</div>
      </div>
    </div>

    <change-brand-modal
      v-if="modalType.changeBrand"
      :brandList="brandListObj.brandList"
      :currentBrandRef="changeBrandInfo.brandInfo['brandRef'] || null"
      @onCloseModal="closeChangeBrandModal"
      @onSubmit="onChangeBrand"
    />

    <change-password-modal
      v-if="modalType.changePassword"
      @onCloseModal="onCloseChangePassword"
      @onSubmit="onChangePassword"
    />
  </b-nav-item-dropdown>
</template>

<script>
import HamburgerSvg from "@/@core/components/svg/common/Hamburger.vue";
import ChangeBrandSvg from "@/@core/components/svg/common/ChangeBrand.vue";
import ChangePasswordSvg from "@/@core/components/svg/common/ChangePassword.vue";
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";
import ChangeBrandModal from "./changeBrandModal.vue";
import useLoginAction from "@/views/pages/authentication/login/hooks/useLoginAction";

import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
  computed,
  onMounted,
} from "@vue/composition-api";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import store from "@/store";
import router from "@/router";
import { async } from "q";
import ChangePasswordModal from "./changePasswordModal.vue";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    HamburgerSvg,
    ChangeBrandSvg,
    ChangeBrandModal,
    ChangePasswordSvg,
    ChangePasswordModal,
  },
  setup() {
    const vm = getCurrentInstance().proxy;

    const { openErrorModal, openDefaultErrorModal } = useValidationModal();

    const {
      submitBrand,
      resetPassword,
      loginForm,
      onSuccessModal,
    } = useLoginAction();

    const modalType = reactive({
      changeBrand: false,
      changePassword: false,
    });

    const { openModal, closeModal } = useModal();

    const openChangeBrandModal = () => {
      modalType.changeBrand = true;
      openModal();
    };

    const closeChangeBrandModal = () => {
      modalType.changeBrand = false;
      closeModal();
    };

    const onOpenChangePassword = () => {
      modalType.changePassword = true;
      openModal();
    };

    const onCloseChangePassword = () => {
      modalType.changePassword = false;
      closeModal();
    };

    const onChangeBrand = (brandItem) => {
      // submitbrand
      window.$loading(true);
      submitBrand({
        accessToken: changeBrandInfo.brandInfo.accessToken,
        refreshToken: changeBrandInfo.brandInfo.refreshToken,
        brandRef: brandItem.value,
        payload: changeBrandInfo.brandInfo.payload,
        state: changeBrandInfo.brandInfo.state,
      })
        .then(() => {
          window.$loading(false);
        })
        .finally(() => {
          window.$loading(false);
        });
    };

    const brandListObj = reactive({
      brandList: [],
    });

    const changeBrandInfo = reactive({
      isChangeBrand: false,
      brandInfo: {},
    });

    const getBrandInfo = () => {
      const brandInfoObj = store.getters["brand/brandInfo"];

      if (Object.keys(brandInfoObj).length > 0) {
        brandInfoObj.brandRef =
          brandInfoObj?.brandRef || router.currentRoute.query.brandRef;

        changeBrandInfo.brandInfo = { ...brandInfoObj };
      }
    };

    const forceLogout = () => {
      let brands = JSON.parse(
        localStorage.getItem(window.brandLocalStorage)
      ).filter((o) => {
        return o.brandRef != sessionStorage.getItem(window.brandSessionStorage);
      });

      localStorage.setItem(window.brandLocalStorage, JSON.stringify(brands));
      // Reset ability
      vm.$ability.update(initialAbility);

      vm.$router.push({ name: "auth-login" });
    };

    const onChangePassword = (passwordForm) => {
      if (!passwordForm) return;

      let brandObj = JSON.parse(
        localStorage.getItem(window.brandLocalStorage)
      )?.find((o) => {
        return (
          o.brandRef ==
            new URLSearchParams(window.location.search).get("brandRef") ||
          o.brandRef == sessionStorage.getItem(window.brandSessionStorage)
        );
      });

      let isNotEmptyObj = brandObj && Object.keys(brandObj).length == 0;

      if (!isNotEmptyObj) {
        resetPassword({
          accessToken: brandObj?.accessToken,
          providerRef: brandObj?.providerRef,
          userName: atob(brandObj?.payload), //decode str base64
          newPassword: passwordForm.newPassword,
          oldPassword: passwordForm.currentPassword,
        }).then((value) => {
          onSuccessModal().then((value) => {
            forceLogout();
          });
        });
      }
    };

    const checkPasswordError = (message) => {
      const showTextError = document.getElementById("show-text-error");
      showTextError.className = "show";
      let div = showTextError.querySelector("div");
      div.innerText = message;
    };

    const accountName = ref("");

    watch(
      () => store.getters["brand/brandList"],
      () => {
        const brandListLength = store.getters["brand/brandList"];
        brandListObj.brandList =
          brandListLength.length > 0 ? brandListLength : [];
        changeBrandInfo.isChangeBrand = brandListLength.length > 1;
      }
    );

    watch(
      () => changeBrandInfo.isChangeBrand,
      () => {
        if (changeBrandInfo.isChangeBrand == true) getBrandInfo();
      }
    );

    onBeforeMount(() => {
      if (localStorage.getItem("account"))
        accountName.value = JSON.parse(localStorage.getItem("account"));
    });

    return {
      modalType,
      openChangeBrandModal,
      closeChangeBrandModal,
      brandListObj,
      changeBrandInfo,
      onChangeBrand,
      onOpenChangePassword,
      onCloseChangePassword,
      onChangePassword,
      forceLogout,
      checkPasswordError,
      accountName,
    };
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      avatarText,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/horizontal-headerbar.css";

#dropdown-user .profile-detail {
  padding: 0 10px;
  font-size: 20px;
}

#dropdown-user .image-user {
  display: flex;
  align-items: center;
  width: 60px;
  height: 60px;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: 30%;
  margin: 0 20px;
  border-radius: 50%;
  justify-content: center;
  color: var(--primary);
  border: 1px solid var(--primary);
}

#dropdown-user .divider {
  height: 1px;
  widows: 100%;
  margin: 10px 0;
  background-color: #e8e8e8;
}

#dropdown-user .footer-sign-out,
#dropdown-user .body-wrp {
  padding: 0 10px;
}

#dropdown-user .sign-out-wrp {
  color: #1589ee;
  font-size: 20px;
  height: 35px;
  width: 100%;
  padding: 20px;
  cursor: pointer;
}

#dropdown-user .sign-out-wrp:hover {
  color: #1589ee;
  background-color: #e5f2ff;
  font-size: 20px;
  height: 35px;
  width: 100%;
  padding: 20px;
  border-radius: 5px;
  cursor: pointer;
}

#dropdown-user .text-email {
  color: #a2a2a2;
}

#dropdown-user .icon-change-brand {
  width: 40px;
  fill: #606a6c;
}

#dropdown-user .text-name-dropdown {
  font-size: 20px;
}

#dropdown-user .body-dropdown {
  color: #606a6c;
  font-size: 20px;
  height: 35px;
  width: 100%;
  padding: 20px 10px;
  cursor: pointer;
}

#dropdown-user .body-dropdown:hover {
  color: #606a6c;
  background-color: #f2f2f2;
  font-size: 20px;
  height: 35px;
  width: 100%;
  padding: 20px 10px;
  border-radius: 5px;
  cursor: pointer;
}

#dropdown-user .feather-user {
  height: 30px;
  width: 30px;
}
</style>

<style>
#dropdown-user ul.dropdown-menu.dropdown-menu-right.show:after {
  position: absolute;
  top: -12px;
  right: 16px;
  display: inline-block;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #000;
  border-left: 12px solid transparent;
  border-bottom-color: #fff;
  content: "";
}

#dropdown-user ul.dropdown-menu.dropdown-menu-right.show {
  width: auto;
  min-width: 10rem;
  height: auto;
  border-radius: 12px;
  padding: 15px 0 10px 0;
  border: 1px solid #c7d0d9;
}
</style>
